/* eslint-disable jsx-a11y/accessible-emoji */
import React, { Component } from "react";
import {
  // Container,
  Image,
  Header,
  Form,
  Message,
  Popup,
  Segment
} from "semantic-ui-react";

import * as CONSTANTS from "../assets/Constants";
import * as LINKS from "../assets/Links";
import saveImageDriveInstructions from "../assets/images/saveImageDriveInstructions.png";

class MemberUpdateForm extends Component {
  state = {
    memberId: "",
    name: "",
    branch: "",
    gender: "",
    hostelType: "",
    github: "",
    linkedIn: "",
    medium: "",
    mobileNum: "",
    driveImage: "",
    currentDesignation: "",
    areasOfExpertise: "",
    milestones: "",
    vision: "",
    success: false,
    error: false,
    errorMsg: "",
    preview: ""
  };

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderProfilePicPreview = this.renderProfilePicPreview.bind(this);
  }

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  };

  componentWillMount() {
    if (!localStorage.getItem("dat")) {
      console.log("You should not be here!");
    } else {
      let id = localStorage.getItem("id");
      fetch(
        LINKS.SERVER_BASE_URL + LINKS.SERVER_ROUTES.memberDataFetchById + id
      )
        .then(response => response.json())
        .then(data => {
          console.log(data);
          this.setState({ memberId: id });
          this.setState({ name: data["member"]["name"] });
          this.setState({ branch: data["member"]["branch"] });
          this.setState({ gender: data["member"]["gender"] });
          this.setState({ hostelType: data["member"]["hostel_type"] });
          this.setState({ github: data["detail"]["github"] });
          this.setState({ linkedIn: data["detail"]["linkedin"] });
          this.setState({ medium: data["detail"]["medium"] });
          this.setState({ mobileNum: data["detail"]["mobile_num"] });
          this.setState({ driveImage: data["detail"]["drive_image"] });
          this.setState({
            currentDesignation: data["detail"]["current_designation"]
          });
          this.setState({
            areasOfExpertise: data["detail"]["areas_of_expertise"]
          });
          this.setState({ milestones: data["detail"]["milestones"] });
          this.setState({ vision: data["detail"]["vision"] });
        });
    }
  }

  componentWillUnmount() {
    localStorage.removeItem("dat");
    localStorage.removeItem("id");
    localStorage.removeItem("email");
  }

  /* handleUpload = event => {
      console.log(event.target.files[0]);
      this.setState({ image: URL.createObjectURL(event.target.files[0]) });
    } */

  renderProfilePicPreview() {
    let preview =
      "https://react.semantic-ui.com/images/avatar/large/christian.jpg";
    // eslint-disable-next-line eqeqeq
    if (this.state.gender == "FEMALE") {
      preview = "https://semantic-ui.com/images/avatar2/large/lindsay.png";
    }
    // eslint-disable-next-line eqeqeq
    if (!this.state.github == "") {
      preview = "https://avatars.githubusercontent.com/" + this.state.github;
    }
    // eslint-disable-next-line eqeqeq
    if (!this.state.driveImage == "") {
      preview = CONSTANTS.DRIVE_URL + this.state.driveImage;
    }
    return <Image size="small" centered src={preview} />;
  }

  handleSubmit() {
    // console.log(this.state);
    const {
      memberId,
      name,
      branch,
      hostelType,
      github,
      linkedIn,
      medium,
      mobileNum,
      driveImage,
      currentDesignation,
      areasOfExpertise,
      milestones,
      vision
    } = this.state;
    // eslint-disable-next-line eqeqeq
    if (mobileNum !== null && (mobileNum.length != 10 || isNaN(mobileNum))) {
      this.setState({ errorMsg: "Incorrect Mobile Number" });
      this.setState({ error: true });
      return;
    }
    fetch(LINKS.SERVER_BASE_URL + LINKS.SERVER_ROUTES.memberDataUpdate, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: localStorage.getItem("dat")
      },
      body: JSON.stringify({
        member: {
          id: memberId,
          name: name,
          branch: branch,
          hostel_type: hostelType
        },
        detail: {
          github: github,
          linkedin: linkedIn,
          medium: medium,
          mobile_num: mobileNum,
          drive_image: driveImage,
          current_designation: currentDesignation,
          areas_of_expertise: areasOfExpertise,
          milestones: milestones,
          vision: vision
        }
      })
    })
      .then(resp => resp.json())
      .then(data => {
        if (!data["success"]) {
          console.log(data);
          this.setState({ error: true, errorMsg: data.error });
        } else {
          // console.log(data);
          this.setState({ success: true });
          console.log("Updated!");
        }
      });
  }

  render() {
    const {
      name,
      branch,
      hostelType,
      github,
      linkedIn,
      medium,
      mobileNum,
      driveImage,
      currentDesignation,
      areasOfExpertise,
      milestones,
      vision
    } = this.state;
    return (
      <Segment style={{ marginBottom: "3em", marginTop: "3em" }}>
        <Header as="h2" textAlign="center">
          Wanna Update Details?
        </Header>
        <Form
          size="medium"
          onSubmit={this.handleSubmit}
          error={this.state.error}
          widths="equal"
        >
          <Form.Input
            fluid
            name="name"
            label="Name"
            icon="user"
            iconPosition="left"
            placeholder="Wanna change your name?"
            value={name}
            onChange={this.handleChange}
            required={true}
          />
          <Form.Dropdown
            fluid
            name="branch"
            label="Branch"
            placeholder="Really! Why do you want to change your branch?"
            value={branch}
            onChange={this.handleChange}
            // clearable
            options={CONSTANTS.branchesList}
            selection
            required={true}
          />
          <Form.Dropdown
            fluid
            name="hostelType"
            label="Hosteler or Day_Scholar"
            placeholder="Did you change from Hosteler to Day Scholar or vice-versa?"
            value={hostelType}
            onChange={this.handleChange}
            // clearable
            options={CONSTANTS.hostelTypeList}
            selection
            required={true}
          />
          <Form.Input
            fluid
            name="mobileNum"
            label="Primary Mobile Number"
            icon="phone"
            iconPosition="left"
            placeholder="Provide the right mobile number, no spam from this website...."
            value={mobileNum}
            onChange={this.handleChange}
          />
          <Message info>
            <Message.Header>
              Sample LinkedIn handle:
              <br />
              https://www.linkedin.com/in/*-(your-handle)-*/
            </Message.Header>
            <Message.Content>
              Your LinkedIn Handle is important for the LinkedIn Badge to show
              up in your Profile in the team page.
            </Message.Content>
          </Message>
          <Form.Input
            fluid
            name="linkedIn"
            label="LinkedIn Handle (Not your public profile link)"
            icon="linkedin"
            iconPosition="left"
            placeholder="Maybe having a LinkedIn profile is kinda more useful than your FB or Insta profile"
            value={linkedIn}
            onChange={this.handleChange}
          />
          <Message info>
            <Message.Header>
              Sample Medium handle:
              <br />
              https://medium.com/@(*-(your-handle)-*)/
            </Message.Header>
          </Message>
          <Form.Input
            fluid
            name="medium"
            label="Medium Handle (Not your public profile link)"
            icon="medium"
            iconPosition="left"
            placeholder="Just register and read blogs, if possible write blogs :)"
            value={medium}
            onChange={this.handleChange}
          />
          <Message info>
            <Message.Header>
              Sample GitHub handle:
              <br />
              https://github.com/*-(your-handle)-*/
            </Message.Header>
            <Message.Content>
              Update your GitHub Avatar to update the Profile picture. If you
              don't have a GitHub account, use an image from your drive.
            </Message.Content>
          </Message>
          <Form.Input
            fluid
            name="github"
            label="GitHub Handle (Not your public profile link)"
            icon="github"
            iconPosition="left"
            placeholder="No words, just another useful profile"
            value={github}
            onChange={this.handleChange}
          />
          {/* <Form.Input
                name="image"
                icon="picture"
                // input={true}
                iconPosition="left"
                type="file"
                // value={image}
                accept="image/*"
                onChange={this.handleUpload}
              /> */}
          <Popup
            key="driveImage"
            trigger={
              <Form.Input
                fluid
                name="driveImage"
                label="File Id of the image from your Google Drive, don't put the whole link, ONLY FILE ID"
                icon="picture"
                iconPosition="left"
                placeholder="Make sure the image is shared to (Anyone with Link) and only put the File Id from the link"
                value={driveImage}
                onChange={this.handleChange}
              />
            }
            header="Follow these instructions"
            content="Open Drive at drive.google.com and select a file.
              Click the Share button at the top of the page.
              Click Advanced in the bottom right corner of the sharing box.
              Click Change....
              Choose On - 'Anyone with Link' and 'Choose Can View' and click Save.
              Before closing the sharing box, copy the document ID from the URL in 
              the field below 'Link to share;. The document ID is a string of uppercase 
              and lowercase letters and numbers between slashes in the URL."
            position="right center"
            // disabled={}
          />
          {/* <Form.Button type='button' onClick={this.renderProfilePicPreview}/> */}
          <Message info>
            <Message.Header>Follow these instructions 🤓:</Message.Header>
            <Message.Content>
              Open Google Drive and select the image, make sure it's less than
              512KB.
              <br />
              Click the Share button at the top of the page.
              <br />
              Click Advanced in the bottom right corner of the sharing box.
              <br />
              Click Change....
              <br />
              Choose On - 'Anyone with Link' and Choose 'Can View' and click
              Save.
              <br />
              Before closing the sharing box, copy the document ID from the URL
              in <br />
              the field below 'Link to share'. (Check the image below)
              <Image size="big" src={saveImageDriveInstructions} />
            </Message.Content>
          </Message>
          <Message info>
            {/* <Message.Header>
              <Image size="big" src={saveImageDriveInstructions} />
            </Message.Header> */}
            <Message.Content>
              <strong>Make sure the file size is less than 512KB.</strong>
              <br />
              Make sure that you don't delete it or move it some another folder
              in your Google Drive.
            </Message.Content>
          </Message>
          <Message info>
            <Message.Header>
              Image Preview (Make sure the image is not broken, check here)
            </Message.Header>
            <Message.Content>
              <br />
              {this.renderProfilePicPreview()}
            </Message.Content>
            <Message.Content>
              <br />
              Wait for the image to load,{" "}
              <strong>
                images from Drive load a bit slow, better to use Image with less
                than 512KB file size.
              </strong>
              <br />
              If you see a broken Image, check the file Id you have given <br />
              OR if you've given GitHub account, <br />
              change the profile pic of your GitHub account. <br />
              Try to follow the instructions carefully. 😕
            </Message.Content>
          </Message>
          <Form.Input
            fluid
            name="currentDesignation"
            label="Current Designation"
            icon="certificate"
            iconPosition="left"
            placeholder="Designation (or Course you're pursuing)"
            value={currentDesignation}
            onChange={this.handleChange}
          />
          <Form.TextArea
            fluid
            name="areasOfExpertise"
            label="Areas of Expertise (seperate by commas)"
            icon="hand spock"
            iconPosition="left"
            placeholder="Mention your areas of expertise seperated by commas"
            value={areasOfExpertise}
            onChange={this.handleChange}
          />
          <Form.TextArea
            fluid
            name="milestones"
            label="Professional (or Personal) milestones reached so Far 🙌 👏"
            icon="checked calendar"
            iconPosition="left"
            placeholder="Professional (or Personal) milestones reached so Far "
            value={milestones}
            onChange={this.handleChange}
          />
          <Form.TextArea
            fluid
            name="vision"
            label="RCS: your Vision"
            icon="star"
            iconPosition="left"
            placeholder="RCS: your vision"
            value={vision}
            onChange={this.handleChange}
          />
          <Message positive success={!this.state.success}>
            <Message.Content>Updated....</Message.Content>
          </Message>
          <Message error>
            <Message.Content>
              {this.state.errorMsg + ", Reload and Retry Again..."}
            </Message.Content>
          </Message>
          <Form.Button
            color="black"
            size="large"
            type="submit"
            disabled={this.state.error || this.state.success}
          >
            Update
          </Form.Button>
        </Form>
      </Segment>
    );
  }
}

export default MemberUpdateForm;
